import {
  BabyDiet,
  BacteriaReport,
  MicrobiomeTestResult,
  Nullable,
  Stats,
  ReportStats,
  ReportSummary,
  BacteriaAttentionAction,
} from '@snapi/types';
import { ReportKeyBacteriaUtils } from './report-key-bacteria-utils';
import { ReportDiversityUtils } from './report-diverstiy-utils';
import { ReportGutBalanceUtils } from './report-gut-balance-utils';
import { ReportDisruptiveBacteriaUtils as ReportDisruptiveBacteriaUtils } from './report-disruptive-bacteria-utils';
import { ReportBacteriaAttentionUtils } from './report-bacteria-attention-utils';
import { ReportRecommendationUtils } from './report-recommendation-utils';
import { ReportConditionUtils } from './report-condition-utils';
import { ReportComparatorUtils } from './report-comparator-utils';

const asReportStats = (
  results: MicrobiomeTestResult[],
  bacteriaReport: BacteriaReport[],
  diversity: number,
  diversityStats: Stats,
  diet: BabyDiet[],
  condition: string[]
): ReportStats => {
  const summary = asReportSummary(
    results,
    bacteriaReport,
    diversity,
    diversityStats,
    condition
  );

  const totalGood = [
    summary.balance.good,
    summary.diversity.good,
    summary.keyBacteria.good,
    summary.disruptive.good,
  ].reduce((sum, good) => sum + (good ? 1 : 0), 0);

  return {
    diversity: summary.diversity.score,
    balance: summary.balance.score,
    disruptive: summary.disruptive.bacteria.length,
    keyBacteria: summary.keyBacteria.bacteria.filter(
      ({ action }) => action !== BacteriaAttentionAction.maintain
    ).length,
    attention: ReportBacteriaAttentionUtils.pick(summary).length,
    recommendation: ReportRecommendationUtils.extract(
      diet,
      summary,
      bacteriaReport
    ).length,
    summary: totalGood,
  };
};

const asReportSummary = (
  results: MicrobiomeTestResult[],
  bacteriaReport: BacteriaReport[],
  diversity: number,
  diversityStats: Nullable<Pick<Stats, 'avg' | 'deviation'>> | null,
  condition: string[]
): ReportSummary => ({
  diversity: ReportDiversityUtils.summary(diversity, {
    avg: diversityStats?.avg || 10,
    deviation: diversityStats?.deviation || 5,
  }),
  balance: ReportGutBalanceUtils.summary(results),
  disruptive: ReportDisruptiveBacteriaUtils.summary(bacteriaReport),
  keyBacteria: ReportKeyBacteriaUtils.summary(bacteriaReport),
  condition: ReportConditionUtils.summary(bacteriaReport, condition),
});

export const ReportUtils = {
  asReportStats,
  asReportSummary,
  comparator: ReportComparatorUtils,
  recomendation: ReportRecommendationUtils,
  attention: ReportBacteriaAttentionUtils,
  condition: ReportConditionUtils,
  disruptive: ReportDisruptiveBacteriaUtils,
  balance: ReportGutBalanceUtils,
  keyBacteria: ReportKeyBacteriaUtils,
  diversity: ReportDiversityUtils,
};
